<template>
	<div ref="container" v-resize="resize" v-if="hasManagerPermission">
		<!-- <v-row class="pa-1">
            <v-col cols="12"> -->
		<v-divider />
		<v-tabs touchless v-model="tab" fixed-tabs center-active>
			<v-tab active-class="primary--text" class="text--darken-2 grey--text" :to="{
				name: 'comerciales',
			}">
				Comerciales
			</v-tab>
			<v-tab active-class="primary--text" class="text--darken-2 grey--text" ref="tab" :to="{
				name: 'proyeccion',
			}">
				Proyección
			</v-tab>
			<v-tab active-class="primary--text" class="text--darken-2 grey--text" ref="tab" :to="{
				name: 'reporte',
			}">
				Reporte
			</v-tab>
			<v-tab active-class="primary--text" class="text--darken-2 grey--text" ref="tab" :to="{
				name: 'estadisticas',
			}">
				Estadísticas
			</v-tab>
			<div ref="top"></div>
		</v-tabs>
		<v-divider />
		<!-- <v-tabs-items v-model="tab">
			<v-tab-item
				class="pa-2"
				:style="{
					background: $vuetify.theme.themes[theme].background,
					'z-index': '4',
				}"
			>
				<ComercialesTable />
			</v-tab-item>
			<v-tab-item
				class="pa-2"
				transition="fade-transition"
				:style="{
					background: $vuetify.theme.themes[theme].background,
					'z-index': '4',
				}"
			>
				<ObjectivesReportBase />
			</v-tab-item>
			<v-tab-item
				class="pa-2"
				:style="{
					background: $vuetify.theme.themes[theme].background,
					'z-index': '4',
				}"
				transition="fade-transition"
			>
				<Stats />
			</v-tab-item>
		</v-tabs-items> -->
		<router-view></router-view>
	</div>
</template>

<script lang="js">
// import ComercialesTable from './ComercialesTable/ComercialesTable.vue';
// import ObjectivesReportBase from './ObjectivesReport/ObjectivesReportBase.vue';
// import Stats from './Stats/Stats.vue';
import { mapGetters } from 'vuex';

export default {
	// components: {
	// 	Stats,
	// 	ComercialesTable,
	// 	ObjectivesReportBase
	// },
	data: () => ({
		tab: null,
		theme: 'light',
		container_width: '100%',
		comerciales_item_height: '100%',
	}),
	computed: {
		...mapGetters('login', {
			hasManagerPermission: 'hasManagerPermission',
		}),
	},
	methods: {
		resize() {
			setTimeout(() => {
				this.container_width = `${this.$refs.container.clientWidth}px`;
				this.comerciales_item_height = `${window.innerHeight - 48 - 60
					}px;`;
				// this.$refs.tab.$parent.$el.classList.add('elevation-6')
			}, 200);
		},
	},
	mounted() {

	},
	beforeCreate() {
		// if (this.$store.state.areaPersonal.calendario.agendados.length == 0 && !this.$store.state.areaPersonal.calendario.requestedAgendados) {
		// 	this.$store.dispatch("areaPersonal/calendario/fetchAgendados")
		// 	this.$store.commit("areaPersonal/calendario/requestedAgendados", true)
		// }
	},
};
</script>
